"use client";

import React from "react";

export default function Signature() {
  // Handle YouTube video in a simple way (Easter Egg - Tron reference)
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open("https://www.youtube.com/embed/wunzmUpzX1M?si=Pmq1KBVYQORM_CPh&clip=Ugkxx6TVRCNGIItk1EX_Nx9iCpq_DZEO5gFR&clipt=EK_dCxiPsg8&autoplay=1", "_blank", "noopener,noreferrer");
  };

  return (
    <p className="text-xs text-gray-500 text-center md:text-right">
      <span 
        onClick={handleClick}
        className="inline-block"
      >
        <span className="shimmer-text">
          I fight for the users!
        </span>
      </span>
    </p>
  );
}